export default "__VITE_ASSET__f03f315a__"